/** Derives basename from the next.js router */ export function getBasename(param) {
    var basePath = param.basePath, locale = param.locale, defaultLocale = param.defaultLocale;
    return locale !== defaultLocale ? "".concat(basePath, "/").concat(locale) : basePath;
}
